import React from "react";
import ContractForm from "../../components/ContractForm";
import { actions } from "../../modules/contracts";
import { connect } from "react-redux";
import { withHandlers, compose, setDisplayName } from "recompose";
import WithFetchContract from "../WithFetchContract/index";
import { continueKeys } from "../../helpers/index";
import JustForStaff from "../JustForStaff/index";
import {
  getCompletedItems,
  getConfirmedItems,
  getRequiredItems
} from "../../modules/items";
import { withRouter } from "react-router-dom";

const withHandleSubmit = withHandlers({
  onSubmit: ({
    updateContract,
    history: { push },
    currentContract
  }) => data => {
    updateContract({
      dealer_id: currentContract.dealer.id,
      data,
      contract_id: currentContract.tracking_number
    }).then(() => {
      push("/contracts");
    });
  },
  onClickTransition: props => transition => data => ev => {
    const finalData = { [transition]: true };
    const { updateContract, currentContract, setCurrentContract } = props;
    if (
      [
        "approve_diagnostic",
        "waiting_for_invoice",
        "waiting_for_payment",
        "waiting_for_pickup"
      ].includes(currentContract.aasm_state)
    ) {
      data[continueKeys[currentContract.aasm_state]] = true;
    }
    updateContract({
      dealer_id: currentContract.dealer.id,
      contract_id: currentContract.tracking_number,
      data: Object.assign({}, data, finalData)
    }).then(contract => {
      setCurrentContract(contract);
    });
  }
});

const mapStateToProps = state => ({
  ...(state.contracts || {}),
  currentDealer: state.dealers.currentDealer,
  currentCustomer: state.customers.currentCustomer,
  currentScooter: state.scooters.currentScooter,
  items: state.items.items,
  requiredItems: getRequiredItems(state),
  confirmedItems: getConfirmedItems(state),
  completedItems: getCompletedItems(state),
  notes: state.notes.notes
});

const mapActionsToProps = {
  updateContract: actions.updateContract,
  setCurrentContract: actions.setCurrentContract
};

const UpdateContractForm = compose(
  WithFetchContract,
  connect(
    mapStateToProps,
    mapActionsToProps
  ),
  withRouter,
  withHandleSubmit
)(ContractForm);

export default compose(
  setDisplayName("UpdateContract"),
  JustForStaff
)(props => (
  <div className="content">
    <h3 className="title">
      <b>Update Contract</b>
    </h3>
    <br />
    <UpdateContractForm {...props} />
  </div>
));
